module.exports = __webpack_public_path__ + "img/88.58f2d608.jpg";